<template>
  <svg
    version="1.1"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="m50 2.5c-26.199 0-47.5 21.301-47.5 47.5s21.301 47.5 47.5 47.5 47.5-21.301 47.5-47.5-21.301-47.5-47.5-47.5zm23.398 63.801c0.69922 0.69922 0.69922 1.6992
    0 2.3984l-4.8008 4.8008c-0.69922 0.69922-1.6992 0.69922-2.3984 0l-16.199-16.301-16.301 16.199c-0.69922 0.69922-1.6992 0.69922-2.3984 0l-4.8008-4.8008c-0.69922-0.69922-0.69922-1.6992
    0-2.3984l16.301-16.199-16.199-16.301c-0.69922-0.69922-0.69922-1.6992 0-2.3984l4.8008-4.8008c0.69922-0.69922 1.6992-0.69922 2.3984 0l16.199 16.301 16.301-16.301c0.69922-0.69922
    1.6992-0.69922 2.3984 0l4.8008 4.8008c0.69922 0.69922 0.69922 1.6992 0 2.3984l-16.301 16.301z" />
  </svg>
</template>
